import React, { Component } from 'react';
import { graphql } from 'react-relay';
import CsatByDeviceTagChart from '../../../../components/CsatByDeviceTagChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query CsatByDeviceTagWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
      $groupByLocation: Boolean
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
              groupByLocation: $groupByLocation
            ) {
              count
              ...CsatByDeviceTagChart_answersReport
            }
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({ subtitleMessageId: 'byTag' })
class CsatByDeviceTagWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <CsatByDeviceTagChart
        answersReport={question.answersReport}
        height={this.props.bodyHeight}
        width={this.props.width}
        uniqueId={widget.id}
      />
    );
  }
}

export default CsatByDeviceTagWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByDeviceTagWidget/CsatByDeviceTagWidget.js